import { Card, Row, Col, Statistic } from "antd";
import { ShoppingOutlined, CheckCircleOutlined, UserOutlined, CarOutlined } from "@ant-design/icons";
import CountUp from "react-countup";

const DashboardCards = ({ todayOrders, assignedOrders, totalDrivers, onlineDrivers, orders, offlineDrivers }) => {
    const formatter = (value) => <CountUp end={value} duration={1.5} separator="," />;

    return (
        <div style={{ paddingTop: 10, paddingBottom: 20 }}>
            <Row gutter={[16, 16]} justify="start" style={{ display: "flex", flexWrap: "wrap" }}>

                {/* All Orders - Blue */}
                <Col xs={24} sm={12} md={8} lg={6} style={{ flex: "1 1 auto", width: 200 }}>
                    <Card hoverable style={{ borderRadius: 10, boxShadow: "0px 4px 10px rgba(0,0,0,0.1)" }}>
                        <Statistic
                            title="All Orders"
                            value={orders}
                            formatter={formatter}
                            valueStyle={{ color: "#1890ff" }}
                            prefix={<ShoppingOutlined style={{ fontSize: 24, color: "#1890ff" }} />}
                        />
                    </Card>
                </Col>

                {/* Today's Orders - Orange */}
                <Col xs={24} sm={12} md={8} lg={6} style={{ flex: "1 1 auto", width: 200 }}>
                    <Card hoverable style={{ borderRadius: 10, boxShadow: "0px 4px 10px rgba(0,0,0,0.1)" }}>
                        <Statistic
                            title="Today's Orders"
                            value={todayOrders}
                            formatter={formatter}
                            valueStyle={{ color: "#fa8c16" }}
                            prefix={<ShoppingOutlined style={{ fontSize: 24, color: "#fa8c16" }} />}
                        />
                    </Card>
                </Col>

                {/* Assigned Orders - Green */}
                <Col xs={24} sm={12} md={8} lg={6} style={{ flex: "1 1 auto", width: 200 }}>
                    <Card hoverable style={{ borderRadius: 10, boxShadow: "0px 4px 10px rgba(0,0,0,0.1)" }}>
                        <Statistic
                            title="Assigned Orders"
                            value={assignedOrders}
                            formatter={formatter}
                            valueStyle={{ color: "#52c41a" }}
                            prefix={<CheckCircleOutlined style={{ fontSize: 24, color: "#52c41a" }} />}
                        />
                    </Card>
                </Col>

                {/* Total Drivers - Purple */}
                <Col xs={24} sm={12} md={8} lg={6} style={{ flex: "1 1 auto", width: 200 }}>
                    <Card hoverable style={{ borderRadius: 10, boxShadow: "0px 4px 10px rgba(0,0,0,0.1)" }}>
                        <Statistic
                            title="Total Drivers"
                            value={totalDrivers}
                            formatter={formatter}
                            valueStyle={{ color: "#722ed1" }}
                            prefix={<UserOutlined style={{ fontSize: 24, color: "#722ed1" }} />}
                        />
                    </Card>
                </Col>

                {/* Online Drivers - Green */}
                <Col xs={24} sm={12} md={8} lg={6} style={{ flex: "1 1 auto", width: 200 }}>
                    <Card hoverable style={{ borderRadius: 10, boxShadow: "0px 4px 10px rgba(0,0,0,0.1)" }}>
                        <Statistic
                            title="Online Drivers"
                            value={onlineDrivers}
                            formatter={formatter}
                            valueStyle={{ color: "#13c2c2" }}
                            prefix={<CarOutlined style={{ fontSize: 24, color: "#13c2c2" }} />}
                        />
                    </Card>
                </Col>

                {/* Offline Drivers */}
                <Col xs={24} sm={12} md={8} lg={6} style={{ flex: "1 1 auto", width: 200 }}>
                    <Card hoverable style={{ borderRadius: 10, boxShadow: "0px 4px 10px rgba(0,0,0,0.1)" }}>
                        <Statistic
                            title="Offline Drivers"
                            value={offlineDrivers}
                            valueStyle={{ color: "green" }}
                            prefix={<CheckCircleOutlined style={{ fontSize: 24, color: "green" }} />}
                        />
                    </Card>
                </Col>

            </Row>
        </div>
    );
};

export default DashboardCards;
